function stubFalse() {
    return false;
}

export { stubFalse };
